import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ToastrService} from "ngx-toastr";
import {AppointmentDataService} from "../../../components/appointment/service/data.service";
import {CompanyService} from "../../../services/Modules/company.service";

class Contact {
    facility: any;
    first_name: string;
    last_name: string;
    phone: string;
    email: string;
    position: string;
    countryCode: string;
    country: string;
}

@Component({
    selector: 'app-facility-contact-dialog',
    templateUrl: './facility-contact-dialog.component.html',
    styleUrls: ['./facility-contact-dialog.component.css']
})
export class FacilityContactDialogComponent implements OnInit {

    facility_id: any;
    public model = new Contact();
    update = false;
    phoneCleaned = '';
    Country = ['US / CA(+1)', 'Philippines(+63)', 'Pak(+92)', 'Ind(+91)'];
    maxMobileLength = 12;
    selectedCountry = ''; 
    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private toastr: ToastrService,
                private dialogRef: MatDialogRef<FacilityContactDialogComponent>,
                private companyService: CompanyService,
                private dataService: AppointmentDataService) {
        if (data.facility_id) {
            this.facility_id = data.facility_id;
        } else if (data.update === true) {
            this.update = true;
            this.model = data.contact;
            if(this.model.countryCode) {
                for(let c of this.Country) {
                    if(c.includes(this.model.countryCode)) {
                        this.model.country = c;
                        this.selectedCountry = c;
                        this.model.phone = this.model.phone.replace(this.model.countryCode, '');
                        this.handlePhoneModelChange(this.model.phone)
                    }
                }
            }
        }
    }

    ngOnInit(): void {
    }

    addContact(obj) {
        if(this.model.phone.includes('-')) {
            this.model.phone = this.model.phone.replace(/-/g,'').trim();
            if (this.selectedCountry === 'Pak(+92)') {
                this.model.phone = '+92' + this.model.phone;
                this.model.countryCode = '+92';
            }
            else if (this.selectedCountry === 'US / CA(+1)') {
                this.model.phone = '+1' + this.model.phone;
                this.model.countryCode = '+1';
            }
            else if (this.selectedCountry === 'Philippines(+63)') {
                this.model.phone = '+63' + this.model.phone;
                this.model.countryCode = '+63';
            }
            else if(this.selectedCountry === 'Ind(+91)') {
                this.model.phone = '+91' + this.model.phone;
                this.model.countryCode = '+91';
            }
        }
        if (this.update === true) {
            this.updateContact(this.model);
            return;
        }
        
        this.model.facility = this.facility_id;
        this.companyService.addFacilityContact(this.model)
            .subscribe(res => {

                this.toastr.success('Facility Contact added', 'Success');
                this.dialogRef.close();
                this.model = new Contact();
            });
    }

    updateContact(contact) {
        this.companyService.updateFacilityContact(this.model)
            .subscribe(res => {
                this.toastr.success('Facility Contact updated', 'Success');
                this.dialogRef.close();
                this.model = new Contact();
            });
    }

    keyPressNumbers(event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        // Only Numbers 0-9
        if ((charCode < 48 || charCode > 57)) {
          event.preventDefault();
          return false;
        }
         else {
          return true;
    }
    
}
handlePhoneModelChange(value) {
    if (this.selectedCountry === 'Philippines(+63)') {
        this.model.phone = value;
        this.phoneCleaned = value;
    }
    else if (value) {
        const cleaned = value.replace(/-/g, '')
        // const cleaned = ('' + value).replace(/\D/g, '');
        // if (cleaned.length <= 10) {
        if(this.selectedCountry === 'Ind(+91)') {
            this.model.phone = cleaned.match(/.{1,4}/g).join('-');
            if(this.model.phone.length > 9) {
                let tempNum = this.model.phone.split('-');
                let num = [tempNum[0], tempNum[1]+ tempNum[2]];
                this.model.phone = num.join('-');
            }
            
        }
        else {
            this.model.phone = cleaned.match(/.{1,3}/g).join('-');
        }
        
        if (this.model.phone.length > 12) {
            let position = this.model.phone.lastIndexOf('-');
            this.model.phone = this.model.phone.substring(0, position) + this.model.phone.substring(position + 1);
        }
        // const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        // if (match) {
        //     this.model.mobile = '(' + match[1] + ') ' + match[2] + '-' + match[3];
        // }
        // else{
        //     this.model.mobile = null;
        // }
        // }
        this.phoneCleaned = cleaned.trim();
        //console.log('phoneCleaned', this.phoneCleaned)
        //console.log('Mobile model', this.model.mobile)
    }
}

countryFilter(Country) {
    this.phoneCleaned = "";
    this.model.phone = "";
    if (Country == 'US / CA(+1)') {
        this.selectedCountry = Country;
        this.maxMobileLength = 12;
        // this.model.mobile = ' +1';
        // (<HTMLInputElement>document.getElementById("mobile")).disabled = false;
    }
    else if (Country === 'Philippines(+63)') {
        this.selectedCountry = Country;
        this.maxMobileLength = 10;
    }
    else if (Country === 'Pak(+92)') {
        this.selectedCountry = Country;
        this.maxMobileLength = 12;
        // this.model.mobile = '+92';
        // (<HTMLInputElement>document.getElementById("mobile")).disabled = false;
    }
    else if(Country === 'Ind(+91)') {
        this.selectedCountry = Country;
        this.maxMobileLength = 11;
    }
}

}
